import { contact } from '@/mocks/homeData';

export default function ContactSection() {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-extrabold text-foreground-950 font-heading mb-3">
            {contact.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            {contact.intro}
          </p>
        </div>

        <div className="max-w-4xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="space-y-6">
            <div className="flex items-start gap-4 p-5 bg-background-50 border border-background-200/70 rounded-xl">
              <div className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1 font-heading">电子邮箱</h3>
                <p className="text-sm text-foreground-500">{contact.email}</p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-5 bg-background-50 border border-background-200/70 rounded-xl">
              <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-wechat-line text-xl text-accent-600"></i>
              </div>
              <div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1 font-heading">微信公众号</h3>
                <p className="text-sm text-foreground-500">{contact.wechat}</p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-5 bg-background-50 border border-background-200/70 rounded-xl">
              <div className="w-11 h-11 rounded-xl bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-weibo-line text-xl text-secondary-600"></i>
              </div>
              <div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1 font-heading">官方微博</h3>
                <p className="text-sm text-foreground-500">{contact.weibo}</p>
              </div>
            </div>

            <div className="p-5 bg-accent-50/60 rounded-xl border border-accent-100">
              <p className="text-xs text-foreground-500 leading-relaxed">
                <i className="ri-information-line mr-1"></i>
                {contact.tips}
              </p>
            </div>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
            <h3 className="text-base font-bold text-foreground-900 mb-5 font-heading">发送消息</h3>
            <form onSubmit={handleSubmit} className="space-y-4" data-readdy-form="contact-form">
              <div>
                <label className="block text-xs font-medium text-foreground-600 mb-1.5">您的称呼</label>
                <input
                  type="text"
                  name="name"
                  placeholder="请输入您的称呼"
                  className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-600 mb-1.5">电子邮箱</label>
                <input
                  type="email"
                  name="email"
                  placeholder="请输入您的邮箱地址"
                  className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-600 mb-1.5">消息内容</label>
                <textarea
                  name="message"
                  rows={4}
                  maxLength={500}
                  placeholder="请输入您的消息（500字以内）"
                  className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                ></textarea>
              </div>
              <div className="honeypot-field">
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <button
                type="submit"
                className="w-full py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                发送消息
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}